async function swymRegistryAddToShopifyCart(products) {
  try {
    const cartData = await swymRegistryShopifyCart();

    for (let index in products) {
      let product = products[index];
      let variantId = parseInt(index);
      let requestedQuantity = parseInt(products[index].quantity);
      let isAvailable =
        product &&
        product?.inventoryPolicy === "DENY" &&
        product?.inventoryQuantity !== undefined &&
        product?.inventoryQuantity !== null &&
        parseInt(product.inventoryQuantity) <= 0
          ? false
          : true;

      if (isAvailable) {
        const existingCartItem = cartData.items.find(
          (item) => item.id === variantId
        );

        if (existingCartItem) {
          const newQuantity = requestedQuantity;

          const maxQuantity = parseInt(product.inventoryQuantity);
          const updatedQuantity =
            newQuantity <= maxQuantity ? newQuantity : maxQuantity;
          const productProperties = existingCartItem.properties
            ? {
                ...existingCartItem.properties,
                swymRegistryItem: true,
              }
            : {
                swymRegistryItem: true,
              };

          const changeResponse = await fetch(
            `${window.Shopify.routes.root}cart/change.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: existingCartItem.key,
                quantity: updatedQuantity,
                properties: productProperties,
              }),
            }
          );

          if (!changeResponse.ok) {
            swymLogger(
              "error",
              `Failed to update cart item. Status: ${changeResponse.status}`,
              "POST"
            );
          }
        } else {
          const maxQuantity = parseInt(product.inventoryQuantity);
          const validQuantity =
            requestedQuantity <= maxQuantity ? requestedQuantity : maxQuantity;

          const addResponse = await fetch(
            `${window.Shopify.routes.root}cart/add.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity: validQuantity,
                    properties: {
                      swymRegistryItem: true,
                    },
                  },
                ],
              }),
            }
          );

          if (!addResponse.ok) {
            swymLogger(
              "error",
              `Failed to add item to cart. Status: ${addResponse.status} `,
              "POST"
            );
          }
        }
      }
    }

    setTimeout(() => {
      reloadPage();
    }, 500);

    return true; 
  } catch (error) {
    swymLogger(
      "error",
      `Failed to add items to cart. Error: ${products} ` +
        error.message +
        " " +
        error.stack,
      "POST"
    );
    return false;
  }
}

function reloadPage() {
  window.location.reload();
}

document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.addEventListener("variant:add", () => {
    setTimeout(() => {
      reloadPage();
    }, 500);
  });

  document.documentElement.addEventListener("cart:change", (event) => {
    const cart = event.detail.cart;
    const items = cart.items;

    const itemRemoved = items.some(item => item.quantity === 0);
    if (itemRemoved) {
      setTimeout(() => {
      reloadPage();
    }, 500);
    }
  });

  console.log("Cart page reload script initialized.");
});
